const OPT_OUT_KEY = 'analytics_opt_out'
const FIRST_SEEN_KEY = 'analytics_first_seen_date'
const LAST_ACTIVE_KEY = 'analytics_last_active_date'

function todayStr() {
  const d = new Date()
  const month = String(d.getMonth() + 1).padStart(2, '0')
  const day = String(d.getDate()).padStart(2, '0')
  return `${d.getFullYear()}-${month}-${day}`
}

// Anonymous visit headers for a price lookup, or null when opted out.
// No identifier ever leaves the browser — only two booleans the server folds
// into daily aggregate counters:
//   X-Visit-First-Today — first lookup today (drives unique-visitors / DAU)
//   X-Visit-New         — this browser has never been seen before (new vs returning)
// Calling this marks today active, so repeat lookups the same day aren't recounted.
export function getVisitHeaders() {
  if (isAnalyticsOptedOut()) return null

  const today = todayStr()
  const newVisitor = !localStorage.getItem(FIRST_SEEN_KEY)
  const firstToday = localStorage.getItem(LAST_ACTIVE_KEY) !== today

  if (newVisitor) localStorage.setItem(FIRST_SEEN_KEY, today)
  if (firstToday) localStorage.setItem(LAST_ACTIVE_KEY, today)

  return {
    'X-Visit-First-Today': firstToday ? '1' : '0',
    'X-Visit-New': newVisitor ? '1' : '0',
  }
}

export function setAnalyticsOptOut(optedOut) {
  if (optedOut) {
    localStorage.setItem(OPT_OUT_KEY, 'true')
    // Clear the local visit state so re-enabling starts fresh.
    localStorage.removeItem(FIRST_SEEN_KEY)
    localStorage.removeItem(LAST_ACTIVE_KEY)
  } else {
    localStorage.removeItem(OPT_OUT_KEY)
  }
}

export function isAnalyticsOptedOut() {
  return localStorage.getItem(OPT_OUT_KEY) === 'true'
}
